/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { UserSettingsOutNotifications } from './userSettingsOutNotifications';

export interface UserSettingsOut {
  capture_enabled: boolean;
  calendar_join_enabled: boolean;
  video_enabled: boolean;
  notifications: UserSettingsOutNotifications;
}
